<div class="header">
  <img src="assets/img/logo-evidentis.svg" alt="Depoto" data-cy="big-logo"/>
  <button class="cursor-pointer" (click)="close()">{{'wizard.btn-close' | translate}}<span class="icon"></span></button>
</div>
<div class="d-flex justify-content-center wizard-page">
  <div class="frame180-frame180">
    <app-menu-item *ngFor="let item of conf; let index =index" [i18nKey]="item.i18nKey | translate"
                   [isDone]="(highestLastStepCompleted$|async) >= index"
                   [wasAlreadyVisited]="(highestStepVisited$|async) >= index"
                   [isActive]="(isActive$| async) === index" [link]="item.routerLink"></app-menu-item>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
